import { RedirectParam, RoutePath } from '../../constants';

export const createRedirectSearchPath = (pathname: string, search: string): string => {
  let searchPath = `?${RedirectParam.redirectTo}=${pathname}`;
  if (search) {
    searchPath += `&${RedirectParam.redirectToParams}=${replacePathParams(search)}`;
  }

  return searchPath;
};

export const getRedirectSearchPath = (searchParams: URLSearchParams): string => {
  const redirectTo = searchParams.get(RedirectParam.redirectTo);
  const redirectToParams = searchParams.get(RedirectParam.redirectToParams);
  const redirectOther = searchParams.get(RedirectParam.redirectOther);

  let params = '';
  if (redirectTo) {
    params += `?${RedirectParam.redirectTo}=${redirectTo}`;

    if (redirectToParams) {
      params += `&${RedirectParam.redirectToParams}=${redirectToParams}`;
    }
  }

  if (redirectOther) {
    params += `&${RedirectParam.redirectOther}=${redirectOther}`;
  }

  return params;
};

export const getUrlToRedirect = (searchParams: URLSearchParams): string | null => {
  const redirectTo = searchParams.get(RedirectParam.redirectTo);
  const redirectToParams = searchParams.get(RedirectParam.redirectToParams);

  if (redirectTo) {
    const redirectToParamsPart = redirectToParams ? `?${getOriginalPathParams(redirectToParams)}` : '';

    return `/${redirectTo}${redirectToParamsPart}`;
  }

  return null;
};

export const needToRedirectToLogin = (currentUrl: string): boolean => {
  return !currentUrl.includes(RoutePath.LOGOUT) && !currentUrl.includes(RoutePath.LOGIN);
};

const replacePathParams = (originalPath: string): string => {
  return originalPath.replace('?', '').replace(/=/g, ':').replace(/&/g, ';');
};

const getOriginalPathParams = (path: string): string => {
  return path.replace(/;/g, '&').replace(/:/g, '=');
};
